"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var RateSearchStore = require("../store/RateSearch");
var RateInfo_1 = require("../components/RateInfo");
var CriteriaInfo_1 = require("../components/CriteriaInfo");
var SearchResultsTextTop_1 = require("../components/SearchResultsTextTop");
var SearchResultsTextMiddle_1 = require("../components/SearchResultsTextMiddle");
var SearchCriteriaText_1 = require("../components/SearchCriteriaText");
var CWSRateSearchResults_1 = require("../components/CWSRateSearchResults");
var Ajax = require("../utils/AjaxUtils");
var reactstrap_1 = require("reactstrap");
var react_datepicker_1 = require("react-datepicker");
require("react-datepicker/dist/react-datepicker.css");
var CWSRateSearch = /** @class */ (function (_super) {
    __extends(CWSRateSearch, _super);
    function CWSRateSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoading: false,
            hasSearched: false,
            searchLoading: false,
            criteria: { insuranceType: '0', groupCode: 'B', effectiveDate: _this.todaysDateToString() },
            plans: {
                frmPlanA: false, frmPlanB: false, frmPlanC: false, frmPlanD: false, frmPlanF: false, frmPlanG: false, frmPlanK: false,
                frmPlanL: false, frmPlanM: false, frmPlanN: false, frmPlanFStar: false, frmPlanGStar: false, frmPlanAllPlans: false,
            },
            rateInfoClicked: false,
            selectedRateId: '',
            countyId: 0,
            countyName: '',
            effectiveDateIsInvalid: false,
            isPlanValid: true,
            searchResults: { rates: [], rateDisplays: [] },
        };
        _this.export = function () {
            _this._searchResultsComponent.current.export();
        };
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.handleEffectiveDateOnChange = _this.handleEffectiveDateOnChange.bind(_this);
        _this.handleRateClicked = _this.handleRateClicked.bind(_this);
        _this._searchResultsComponent = React.createRef();
        _this.handleEffectiveDateOnBlur = _this.handleEffectiveDateOnBlur.bind(_this);
        return _this;
    }
    // This method is called when the component is first added to the document
    CWSRateSearch.prototype.componentDidMount = function () {
    };
    CWSRateSearch.prototype.todaysDateToString = function () {
        var now = new Date();
        var todaysDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0).toISOString().split('T')[0];
        return todaysDate.split('-')[1] + "/" + todaysDate.split('-')[2] + "/" + todaysDate.split('-')[0];
        //return d.getFullYear().toString() + "-" + (d.getMonth() + 1).toString() + "-" + d.getDate().toString();
    };
    // This method is called when the route parameters change
    CWSRateSearch.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.countyId != this.props.countyId && this.props.countyId !== 0) {
            this.getCounties();
        }
    };
    CWSRateSearch.prototype.getCounties = function () {
        var countyId = this.props.countyId || 0;
        this.props.requestZipCodes(countyId);
        this.setState({ countyId: countyId, countyName: this.props.countyName, countyZipCodes: this.props.countyZipCodes });
    };
    CWSRateSearch.prototype.handleEffectiveDateOnChange = function (d) {
        var _this = this;
        var effectiveDateString = "";
        if (d !== null) {
            var dString = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0).toISOString().split('T')[0];
            effectiveDateString = dString.split('-')[1] + "/" + dString.split('-')[2] + "/" + dString.split('-')[0];
        }
        this.setState(function () { return ({
            criteria: __assign(__assign({}, _this.state.criteria), { effectiveDate: effectiveDateString })
        }); });
    };
    CWSRateSearch.prototype.handleInputChange = function (event) {
        var _this = this;
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        if (target.type !== 'checkbox') {
            this.setState(function () {
                var _a;
                return ({
                    criteria: __assign(__assign({}, _this.state.criteria), (_a = {}, _a[name] = value, _a))
                });
            });
        }
        else {
            if (name !== 'frmPlanAllPlans') {
                this.setState(function () {
                    var _a;
                    return ({
                        plans: __assign(__assign({}, _this.state.plans), (_a = {}, _a[name] = value, _a))
                    });
                });
            }
            else {
                var allPlansChecked_1 = event.target.checked;
                this.setState(function () { return ({
                    plans: __assign(__assign({}, _this.state.plans), { frmPlanA: allPlansChecked_1, frmPlanB: allPlansChecked_1, frmPlanC: allPlansChecked_1, frmPlanD: allPlansChecked_1, frmPlanF: allPlansChecked_1, frmPlanG: allPlansChecked_1, frmPlanK: allPlansChecked_1, frmPlanL: allPlansChecked_1, frmPlanM: allPlansChecked_1, frmPlanN: allPlansChecked_1, frmPlanFStar: allPlansChecked_1, frmPlanGStar: allPlansChecked_1, frmPlanAllPlans: allPlansChecked_1 })
                }); });
            }
        }
    };
    CWSRateSearch.prototype.handleSearch = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var plans, c, searchResults;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        plans = '';
                        if (this.state.plans.frmPlanA)
                            plans += "A,";
                        if (this.state.plans.frmPlanB)
                            plans += "B,";
                        if (this.state.plans.frmPlanC)
                            plans += "C,";
                        if (this.state.plans.frmPlanD)
                            plans += "D,";
                        if (this.state.plans.frmPlanF)
                            plans += "F,";
                        if (this.state.plans.frmPlanG)
                            plans += "G,";
                        if (this.state.plans.frmPlanK)
                            plans += "K,";
                        if (this.state.plans.frmPlanL)
                            plans += "L,";
                        if (this.state.plans.frmPlanM)
                            plans += "M,";
                        if (this.state.plans.frmPlanN)
                            plans += "N,";
                        if (this.state.plans.frmPlanFStar)
                            plans += "F*,";
                        if (this.state.plans.frmPlanGStar)
                            plans += "G*,";
                        if (!this.isValidEffectiveDate(this.state.criteria.effectiveDate)) {
                            return [2 /*return*/, 1];
                        }
                        if (plans === '') {
                            this.setState({ isPlanValid: false });
                            return [2 /*return*/, 1];
                        }
                        else {
                            this.setState({ isPlanValid: true });
                        }
                        c = { age: this.state.criteria.age, gender: this.state.criteria.gender, insuranceType: this.state.criteria.insuranceType, plans: plans.slice(0, -1), smoker: this.state.criteria.smoker, zipCode: this.state.criteria.zipCode, effectiveDate: this.state.criteria.effectiveDate, groupCode: this.state.criteria.groupCode };
                        this.setState({ criteria: c, searchLoading: true });
                        return [4 /*yield*/, Ajax.get("api/MCWSSearch/GetSearchResults?age=" + c.age + "&gender=" + c.gender + "&smoker=" + c.smoker + "&zipCode=" + c.zipCode + "&insuranceType=" + c.insuranceType + "&plans=" + c.plans + "&effectiveDate=" + c.effectiveDate + "&groupCode=" + c.groupCode)];
                    case 1:
                        searchResults = _a.sent();
                        this.setState({ hasSearched: true, searchResults: searchResults, skip: 0, searchLoading: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    CWSRateSearch.prototype.isValidEffectiveDate = function (d) {
        var isValid = true;
        var inputDate = new Date(d + " 00:00");
        var now = new Date();
        var todaysDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0);
        //let minDate = Date.parse('2019-12-20 00:00');
        //let maxDate = Date.parse('2020-12-20 00:00');
        if (inputDate < todaysDate) {
            this.setState({ effectiveDateIsInvalid: true });
            isValid = false;
        }
        else {
            this.setState({ effectiveDateIsInvalid: false });
            isValid = true;
        }
        return isValid;
    };
    CWSRateSearch.prototype.handleEffectiveDateOnBlur = function (event) {
        if (!this.isValidEffectiveDate(event.target.value)) {
            //reset text to blank string... invalid date
            //event.target.value = '';
        }
    };
    CWSRateSearch.prototype.clearSearch = function (event) {
        event.preventDefault();
        this.props.clearSearch();
        this.setState({
            hasSearched: false, rateInfoClicked: false, selectedRateId: '', criteria: { age: "", gender: "", insuranceType: "0", plans: "", smoker: "", zipCode: "", effectiveDate: this.todaysDateToString(), groupCode: "B" },
            plans: {
                frmPlanA: false, frmPlanB: false, frmPlanC: false, frmPlanD: false, frmPlanF: false, frmPlanG: false, frmPlanK: false,
                frmPlanL: false, frmPlanM: false, frmPlanN: false, frmPlanFStar: false, frmPlanGStar: false, frmPlanAllPlans: false,
            },
            searchResults: { rates: [], rateDisplays: [] }
        });
    };
    CWSRateSearch.prototype.newSearch = function (event) {
        event.preventDefault();
        //Keep County Information and Search Form criteria... re display Search Form
        this.setState({ hasSearched: false, rateInfoClicked: false, selectedRateId: '', searchResults: { rates: [], rateDisplays: [] } });
    };
    CWSRateSearch.prototype.helpClick = function (event) {
        event.preventDefault();
    };
    CWSRateSearch.prototype.getAgeSelections = function () {
        var ageSelections = [
            { key: 64, value: "0-64", description: '0-64' },
        ];
        for (var i = 65; i < 100; i++) {
            ageSelections.push({ key: i, value: i.toString(), description: i.toString() });
        }
        return ageSelections;
    };
    CWSRateSearch.prototype.renderForm = function () {
        var ageSelections = this.getAgeSelections();
        var ageOptions = ageSelections.map(function (option) {
            return React.createElement("option", { value: option.value, key: option.key }, option.description);
        });
        var zipCodes = this.props.countyZipCodes;
        var zipCodeOptions = zipCodes.map(function (option) {
            return React.createElement("option", { value: option.zipcodE_DS, key: option.zipcodE_DS }, option.zipcodE_DS);
        });
        return React.createElement("form", { onSubmit: this.handleSearch, name: "form1" },
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: "control-label col-md-4 font-weight-bold text-right", htmlFor: "age" }, "Age"),
                React.createElement("div", { className: "col-md-1" },
                    React.createElement("a", { id: "ageHelp", href: "#", onClick: this.helpClick.bind(this), style: { paddingRight: '2px', paddingLeft: '2px', fontWeight: 'bold', cursor: 'pointer', color: '#fff', backgroundColor: '#8db9ca' }, tabIndex: -1 }, "?"),
                    React.createElement(reactstrap_1.UncontrolledPopover, { trigger: "focus", placement: "bottom", target: "ageHelp" },
                        React.createElement(reactstrap_1.PopoverHeader, null, "Age Criteria"),
                        React.createElement(reactstrap_1.PopoverBody, null, "Entering your age allows the system to narrow the scope of the rates that will be displayed. Premium rates vary based on the applicant's age at the issuance of the policy/certificate. The premium does not change each year merely because the person has grown older. The premium may change due to medical inflation or adverse experience on the block of business."))),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("select", { "data-val": "true", id: "age", name: "age", required: true, onChange: this.handleInputChange.bind(this), value: this.state.criteria.age },
                        React.createElement("option", { key: "-1", value: "" }, "---(Select One)---"),
                        ageOptions,
                        React.createElement("option", { key: "100", value: "100" }, "100+")))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: "control-label col-md-4 font-weight-bold text-right", htmlFor: "gender" }, "Gender"),
                React.createElement("div", { className: "col-md-1" },
                    React.createElement("a", { id: "genderHelp", href: "#", onClick: this.helpClick.bind(this), style: { paddingRight: '2px', paddingLeft: '2px', fontWeight: 'bold', cursor: 'pointer', color: '#fff', backgroundColor: '#8db9ca' }, tabIndex: -1 }, "?"),
                    React.createElement(reactstrap_1.UncontrolledPopover, { trigger: "focus", placement: "bottom", target: "genderHelp" },
                        React.createElement(reactstrap_1.PopoverHeader, null, "Gender Criteria"),
                        React.createElement(reactstrap_1.PopoverBody, null, "Rates may vary based on gender of the applicant."))),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("select", { "data-val": "true", required: true, id: "gender", name: "gender", onChange: this.handleInputChange.bind(this), value: this.state.criteria.gender },
                        React.createElement("option", { key: "-1", value: "" }, "---(Select One)---"),
                        React.createElement("option", { key: "0", value: "m" }, "Male"),
                        React.createElement("option", { key: "1", value: "f" }, "Female")))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: "control-label col-md-4 font-weight-bold text-right", htmlFor: "smoker" }, "Smoker"),
                React.createElement("div", { className: "col-md-1" },
                    React.createElement("a", { id: "smokerHelp", href: "#", onClick: this.helpClick.bind(this), style: { paddingRight: '2px', paddingLeft: '2px', fontWeight: 'bold', cursor: 'pointer', color: '#fff', backgroundColor: '#8db9ca' }, tabIndex: -1 }, "?"),
                    React.createElement(reactstrap_1.UncontrolledPopover, { trigger: "focus", placement: "bottom", target: "smokerHelp" },
                        React.createElement(reactstrap_1.PopoverHeader, null, "Smoker Criteria"),
                        React.createElement(reactstrap_1.PopoverBody, null, "Rates may vary depending upon whether the applicant uses tobacco."))),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("select", { "data-val": "true", id: "smoker", name: "smoker", required: true, onChange: this.handleInputChange.bind(this), value: this.state.criteria.smoker },
                        React.createElement("option", { key: "-1", value: "" }, "---(Select One)---"),
                        React.createElement("option", { key: "0", value: "s" }, "Smoker"),
                        React.createElement("option", { key: "1", value: "o" }, "Non-Smoker")))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: "control-label col-md-4 font-weight-bold text-right", htmlFor: "insuranceType" }, "Insurance Type"),
                React.createElement("div", { className: "col-md-1" },
                    React.createElement("a", { id: "insuranceTypeHelp", href: "#", onClick: this.helpClick.bind(this), style: { paddingRight: '2px', paddingLeft: '2px', fontWeight: 'bold', cursor: 'pointer', color: '#fff', backgroundColor: '#8db9ca' }, tabIndex: -1 }, "?"),
                    React.createElement(reactstrap_1.UncontrolledPopover, { trigger: "focus", placement: "bottom", target: "insuranceTypeHelp" },
                        React.createElement(reactstrap_1.PopoverHeader, null, "Insurance Type Criteria"),
                        React.createElement(reactstrap_1.PopoverBody, null, "The insurance type helps to determine which rates will be displayed. Medicare Select policies offer the same basic coverage as the Standard plans available through traditional Medicare Supplement insurance. However, insurance companies my require consumers who obtain Medicare Select policies to use a specific network of health care providers and/or facilities."))),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("select", { "data-val": "true", id: "insuranceType", name: "insuranceType", required: true, onChange: this.handleInputChange.bind(this), value: this.state.criteria.insuranceType },
                        React.createElement("option", { key: "-1", value: "" }, "---(Select One)---"),
                        React.createElement("option", { key: "0", value: "0" }, "Both"),
                        React.createElement("option", { key: "1", value: "3" }, "Select"),
                        React.createElement("option", { key: "2", value: "5" }, "Standard")))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: "control-label col-md-4 font-weight-bold text-right", htmlFor: "goupCode" }, "Plan Type"),
                React.createElement("div", { className: "col-md-1" },
                    React.createElement("a", { id: "groupCodeHelp", href: "#", onClick: this.helpClick.bind(this), style: { paddingRight: '2px', paddingLeft: '2px', fontWeight: 'bold', cursor: 'pointer', color: '#fff', backgroundColor: '#8db9ca' }, tabIndex: -1 }, "?"),
                    React.createElement(reactstrap_1.UncontrolledPopover, { trigger: "focus", placement: "bottom", target: "groupCodeHelp" },
                        React.createElement(reactstrap_1.PopoverHeader, null, "Plan Type Criteria"),
                        React.createElement(reactstrap_1.PopoverBody, null, "Group coverage typically requires members to be a part of a particular association to be eligible for coverage. Specific requirements can be found by contacting the insurance company. Individual coverage does not require membership or association with a particular group."))),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("select", { "data-val": "true", id: "groupCode", name: "groupCode", required: true, onChange: this.handleInputChange.bind(this), value: this.state.criteria.groupCode },
                        React.createElement("option", { key: "-1", value: "" }, "---(Select One)---"),
                        React.createElement("option", { key: "0", value: "B" }, "Both"),
                        React.createElement("option", { key: "1", value: "Individual" }, "Individual"),
                        React.createElement("option", { key: "2", value: "Group" }, "Group")))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: "control-label col-md-4 font-weight-bold text-right", htmlFor: "zipCode" }, "Zip Code"),
                React.createElement("div", { className: "col-md-1" },
                    React.createElement("a", { id: "zipcodeHelp", href: "#", onClick: this.helpClick.bind(this), style: { paddingRight: '2px', paddingLeft: '2px', fontWeight: 'bold', cursor: 'pointer', color: '#fff', backgroundColor: '#8db9ca' }, tabIndex: -1 }, "?"),
                    React.createElement(reactstrap_1.UncontrolledPopover, { trigger: "focus", placement: "bottom", target: "zipcodeHelp" },
                        React.createElement(reactstrap_1.PopoverHeader, null, "Zip Code Criteria"),
                        React.createElement(reactstrap_1.PopoverBody, null, "Entering your Florida zip code allows the system to narrow the scope of the rates that will be displayed. The rates displayed are only for the area in which you reside."))),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("select", { "data-val": "true", id: "zipCode", name: "zipCode", required: true, onChange: this.handleInputChange.bind(this), value: this.state.criteria.zipCode },
                        React.createElement("option", { key: "-1", value: "" }, "---(Select One)---"),
                        zipCodeOptions),
                    React.createElement("span", null,
                        ".....In ",
                        this.state.countyName,
                        " County"))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("label", { className: "control-label col-md-4 font-weight-bold text-right", htmlFor: "effectiveDate" }, "Effective Date"),
                React.createElement("div", { className: "col-md-1" },
                    React.createElement("a", { id: "effectiveDateHelp", href: "#", onClick: this.helpClick.bind(this), style: { paddingRight: '2px', paddingLeft: '2px', fontWeight: 'bold', cursor: 'pointer', color: '#fff', backgroundColor: '#8db9ca' }, tabIndex: -1 }, "?"),
                    React.createElement(reactstrap_1.UncontrolledPopover, { trigger: "focus", placement: "bottom", target: "effectiveDateHelp" },
                        React.createElement(reactstrap_1.PopoverHeader, null, "Effective Date Criteria"),
                        React.createElement(reactstrap_1.PopoverBody, null,
                            "Enter the date you would like coverage to begin.",
                            React.createElement("br", null),
                            "Format: 01/01/2020"))),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement(react_datepicker_1.default, { required: true, selected: (this.state.criteria.effectiveDate) != null && this.state.criteria.effectiveDate !== "" ? new Date(this.state.criteria.effectiveDate + " 00:00") : null, onChange: this.handleEffectiveDateOnChange.bind(this), onBlur: this.handleEffectiveDateOnBlur, dateFormat: 'MM/dd/yyyy', todayButton: "Today" }),
                    React.createElement("div", { style: { display: !this.state.effectiveDateIsInvalid ? 'none' : '', color: 'Red' } }, "Effective Date cannot be less than today's date."))),
            React.createElement("div", { className: "form-group row", id: "divPlans" },
                React.createElement("label", { className: "control-label col-md-4 font-weight-bold text-right", htmlFor: "divPlans" }, "Plans"),
                React.createElement("div", { className: "col-md-1" },
                    React.createElement("a", { id: "plansHelp", href: "#", onClick: this.helpClick.bind(this), style: { paddingRight: '2px', paddingLeft: '2px', fontWeight: 'bold', cursor: 'pointer', color: '#fff', backgroundColor: '#8db9ca' }, tabIndex: -1 }, "?"),
                    React.createElement(reactstrap_1.UncontrolledPopover, { trigger: "focus", placement: "bottom", target: "plansHelp" },
                        React.createElement(reactstrap_1.PopoverHeader, null, "Plans Criteria"),
                        React.createElement(reactstrap_1.PopoverBody, null, "Select all plans for which you would like to compare rates. Please see the Consumer Guide for a description of benefits by plan."))),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "row border border-dark" },
                        React.createElement("div", { className: "col-sm-12", style: { display: this.state.isPlanValid ? 'none' : '', color: 'Red' } },
                            "A plan must be selected.",
                            React.createElement("br", null)),
                        React.createElement("div", { className: "col-sm-3" },
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanA", "aria-label": "A", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanA }),
                            "A",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanB", "aria-label": "B", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanB }),
                            "B",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanC", "aria-label": "C", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanC }),
                            "C",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanD", "aria-label": "D", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanD }),
                            "D",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanF", "aria-label": "F", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanF }),
                            "F"),
                        React.createElement("div", { className: "col-sm-3" },
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanG", "aria-label": "G", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanG }),
                            "G",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanK", "aria-label": "K", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanK }),
                            "K",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanL", "aria-label": "L", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanL }),
                            "L",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanM", "aria-label": "M", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanM }),
                            "M"),
                        React.createElement("div", { className: "col-sm-6" },
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanN", "aria-label": "N", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanN }),
                            "N",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" }, type: "checkbox", name: "frmPlanFStar", "aria-label": "F*", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanFStar }),
                            "F*",
                            React.createElement("br", null),
                            React.createElement("input", { style: { marginRight: "5px" },type: "checkbox", name: "frmPlanGStar", "aria-label": "G*", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanGStar }),
                            "G*",
                            React.createElement("br", null),
                            React.createElement("span", null,
                                React.createElement("input", { style: { marginRight: "5px" },type: "checkbox", name: "frmPlanAllPlans", "aria-label": "All Plans", onChange: this.handleInputChange.bind(this), checked: this.state.plans.frmPlanAllPlans }),
                                "All Plans")),
                        React.createElement("div", { className: "col-sm-12 text font-weight-bold" },
                            "* High Deductible Plan",
                            React.createElement("br", null))))),
            React.createElement("div", { className: "form-group row" },
                React.createElement("span", { className: "col-md-5" }),
                React.createElement("div", null,
                    React.createElement("button", { type: "submit" }, "Search"),
                    React.createElement("button", { type: "button", onClick: this.clearSearch.bind(this), style: { marginLeft: '5px' } }, "Clear Search Criteria"))));
    };
    CWSRateSearch.prototype.handleRateClicked = function (rateId) {
        this.setState({ rateInfoClicked: true, selectedRateId: rateId });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    CWSRateSearch.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            (!this.state.hasSearched) ? React.createElement(SearchCriteriaText_1.default, null) : React.createElement(SearchResultsTextTop_1.default, null),
            React.createElement("br", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-6" }, (!this.state.hasSearched) ? this.renderForm() : React.createElement(CriteriaInfo_1.default, { criteria: this.state.criteria })),
                React.createElement("div", { className: "col-sm-6" }, (this.state.rateInfoClicked) ? React.createElement(RateInfo_1.default, { rate: this.state.searchResults.rates.filter(function (x) { return x.ratE_ID.toString() == _this.state.selectedRateId; })[0] }) : '')),
            React.createElement("br", null),
            this.state.hasSearched ? React.createElement(SearchResultsTextMiddle_1.default, null) : '',
            this.state.searchLoading && React.createElement("div", { className: "text-center", role: "status" },
                React.createElement("div", { className: "spinner-border text-primary", role: "status" },
                    React.createElement("span", { className: "sr-only" }, "Loading..."))),
            React.createElement("br", null),
            React.createElement("div", null, this.state.hasSearched ? React.createElement(CWSRateSearchResults_1.default, { rateDisplays: this.state.searchResults.rateDisplays, plans: this.state.criteria.plans, onHandleRateClicked: this.handleRateClicked, ref: this._searchResultsComponent }) : ''),
            this.state.hasSearched && React.createElement("div", null,
                React.createElement("br", null),
                React.createElement("button", { style: { marginRight: "10px"}, onClick: this.newSearch.bind(this) }, "New Search"),
                React.createElement("button", { title: "Export Excel", onClick: this.export }, "Export to Excel"))));
    };
    return CWSRateSearch;
}(React.PureComponent));
;
exports.default = react_redux_1.connect(function (state) { return state.rateSearch; }, RateSearchStore.actionCreators)(CWSRateSearch);
//# sourceMappingURL=CWSRateSearch.js.map